import { createContext, useContext, useEffect, type ReactNode } from 'react';

export interface PageTitleApi {
  setTitle: (t: ReactNode) => void;
}

export const PageTitleContext = createContext<PageTitleApi>({ setTitle: () => {} });

/**
 * Sets the top-bar context line for the current page. Pass a STABLE node (a string, or a
 * useMemo'd element) — an inline JSX element recreated each render would loop the effect.
 */
export function usePageTitle(title: ReactNode): void {
  const { setTitle } = useContext(PageTitleContext);
  useEffect(() => {
    setTitle(title);
    return () => setTitle(null);
  }, [title, setTitle]);
}
